import useState from "./useState";


interface IStateValues {
    open: boolean;
}

const useDrawer = () => {
    const state = useState<IStateValues>({
        open: false
    });

    return {
        open: state.values.open,
        handleOpen: () => state.update('open', true),
        handleClose: () => state.update('open', false)
    };
}

export default useDrawer;